// Minimal inline emphasis for FAQ copy. Content files mark a lead-in with
// **double asterisks**; the page renders it bold and the PDF switches to the
// bold font face. Deliberately the only markup supported, so the content files
// stay readable as plain sentences.

export interface TextSegment {
  text: string;
  bold: boolean;
}

const MARKER = '**';

/**
 * Split a string into plain and bold segments. An unbalanced marker count means
 * the copy has a typo, so the whole string is returned plain rather than
 * silently bolding the tail.
 */
export function parseBold(input: string): TextSegment[] {
  const parts = input.split(MARKER);
  if (parts.length % 2 === 0) {
    return [{ text: input, bold: false }];
  }
  return parts
    .map((text, index) => ({ text, bold: index % 2 === 1 }))
    .filter(segment => segment.text.length > 0);
}

/** True when every bold marker in the string is closed. */
export function hasBalancedMarkers(input: string): boolean {
  return input.split(MARKER).length % 2 === 1;
}
